// extracted by mini-css-extract-plugin
export default {"main-container":"Searchbar_main-container__0Ooqa"};